import ReactGA from 'react-ga4';

// Initialize Google Analytics
const GA_MEASUREMENT_ID = 'G-VWFZRPHR57';

// Analytics utility for tracking user interactions and performance
export const trackEvent = (eventName: string, properties?: Record<string, any>) => {
  // In production, you would integrate with Google Analytics, Mixpanel, etc.
  if (process.env.NODE_ENV === 'development') {
    console.log('Analytics Event:', eventName, properties);
  }
  
  // Google Analytics 4
  try {
    ReactGA.event({
      category: 'User Interaction',
      action: eventName,
      ...properties
    });
  } catch (error) {
    console.warn('Analytics error:', error);
  }
};

export const trackPageView = (pageName: string) => {
  try {
    ReactGA.send({ hitType: "pageview", page: `/${pageName}` });
    if (process.env.NODE_ENV === 'development') {
      console.log('Page View:', pageName);
    }
  } catch (error) {
    console.warn('Page view tracking error:', error);
  }
};

export const trackScrollDepth = (depth: number) => {
  trackEvent('scroll_depth', { depth });
};

export const trackInteraction = (element: string, action: string) => {
  trackEvent('interaction', { element, action });
};

export const trackPerformance = (metric: string, value: number) => {
  trackEvent('performance', { metric, value });
};

// Initialize Google Analytics
export const initializeAnalytics = () => {
  try {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    console.log('Google Analytics initialized successfully');
  } catch (error) {
    console.warn('Failed to initialize Google Analytics:', error);
  }
};

// Enhanced tracking functions
export const trackButtonClick = (buttonName: string, location: string) => {
  trackEvent('button_click', { button_name: buttonName, location });
};

export const trackFormSubmission = (formName: string) => {
  trackEvent('form_submission', { form_name: formName });
};

export const trackSocialMediaClick = (platform: string) => {
  trackEvent('social_media_click', { platform });
}; 